<ng-container *ngIf="(settingsService.settings$ | async)?.pageReferences?.searchPage?.url as searchPageUrl">
    <div #searchContainer>
        <form #searchForm (ngSubmit)="handleSubmit(searchPageUrl, searchInputComponent.searchInput.value)">
            <app-search-input
                #searchInputComponent
                (searchValue)="searchStateService.setSearchTerm($event)"
            ></app-search-input>
        </form>
        <div
            class="search-dropdown kk-content-fade-in"
            #dropdown
            (appNgAfterViewInit)="setTop(dropdown)"
            *ngIf="(siteStateService.state$ | async)?.search"
        >
            <div class="search-backdrop" (click)="searchStateService.close()"></div>
            <div class="search-content-wrapper" *ngIf="searchStateService.searchTerm$ | async as searchTerm">
                <div
                    class="search-content"
                    *ngIf="
                        searchStateService.contentSearchResults$
                            | async
                            | showSearchContent: (searchStateService.productSearchResults$ | async)
                    "
                >
                    <div class="container">
                        <div class="row">
                            <div class="col col-12 col-md-5 col-xl-4">
                                <ng-container *ngIf="searchStateService.productSearchResults$ | async as searchResults">
                                    <ng-container *ngIf="searchResults?.suggestions as suggestions">
                                        <div *ngIf="suggestions.searchWords?.length || suggestions.didYouMean?.length">
                                            <div
                                                [ngClass]="{
                                                    searching: searchStateService.productSearchInProgress$ | async
                                                }"
                                            >
                                                <section *ngIf="suggestions.searchWords?.length">
                                                    <h3 class="display-label">
                                                        {{ 'search.headings.searchResults' | translateSafe }}
                                                    </h3>
                                                    <ol class="result-text">
                                                        <li *ngFor="let item of suggestions.searchWords">
                                                            <button
                                                                appSetIsFocused
                                                                class="result-text highlight-text action kk-overflow-ellipsis kk-hover-underline"
                                                                (click)="
                                                                    setInputValueAndSubmit(searchPageUrl, item.name)
                                                                "
                                                                *ngIf="item.name"
                                                            >
                                                                <span
                                                                    [innerHTML]="
                                                                        item.name
                                                                            | highlight
                                                                                : searchInputComponent.searchInput.value
                                                                    "
                                                                ></span>
                                                            </button>
                                                        </li>
                                                    </ol>
                                                </section>
                                                <section *ngIf="suggestions.didYouMean?.length">
                                                    <h3 class="display-label">
                                                        {{ 'search.headings.didYouMean' | translateSafe }}
                                                    </h3>
                                                    <ol>
                                                        <li *ngFor="let item of suggestions.didYouMean">
                                                            <button
                                                                appSetIsFocused
                                                                *ngIf="item.name"
                                                                class="result-text action kk-overflow-ellipsis kk-hover-underline"
                                                                (click)="
                                                                    setInputValueAndSubmit(searchPageUrl, item.name)
                                                                "
                                                            >
                                                                {{ item.name }}
                                                            </button>
                                                        </li>
                                                    </ol>
                                                </section>
                                            </div>
                                        </div>
                                        <div
                                            class="d-md-none"
                                            *ngIf="(breakpointMinService.breakpoint$ | async)?.isMobile"
                                        >
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    products;
                                                    context: {
                                                        results: searchResults,
                                                        url: searchPageUrl
                                                    }
                                                "
                                            ></ng-container>
                                        </div>
                                    </ng-container>

                                    @if ((breakpointMinService.breakpoint$ | async)?.isMobile) {
                                        <ng-container [ngTemplateOutlet]="commonLink"
                                                      [ngTemplateOutletContext]="{
                                                        searchResults: searchResults,
                                                        searchPageUrl: searchPageUrl,
                                                        content: ('search.links.seeAllResults' | translateSafe)
                                                       }"
                                        ></ng-container>
                                    }
                                </ng-container>

                                <ng-container
                                    *ngIf="searchStateService.contentSearchResults$ | async as contentResults"
                                >
                                    <div [ngClass]="{ searching: searchStateService.contentSearchInProgress$ | async }">
                                        <app-search-content-results
                                            [headline]="'search.headings.categories' | translateSafe"
                                            [contentResults]="contentResults | getByContentType: 'ProductFilterPage'"
                                        >
                                        </app-search-content-results>
                                        <app-search-content-results
                                            [headline]="'search.headings.brands' | translateSafe"
                                            [contentResults]="contentResults | getByContentType: 'BrandPage'"
                                        >
                                        </app-search-content-results>
                                        <app-search-content-results
                                            [headline]="'search.headings.articles' | translateSafe"
                                            [contentResults]="
                                                contentResults | getByContentType: 'ArticlePage':'RecipePage'
                                            "
                                            [showType]="true"
                                        ></app-search-content-results>
                                        <ng-container *ngIf="contentResults.length">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    seeAllLink;
                                                    context: {
                                                        content: ('search.links.seeAllResults' | translateSafe),
                                                        url: searchPageUrl
                                                    }
                                                "
                                            ></ng-container>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                            <div
                                *ngIf="!(breakpointMinService.breakpoint$ | async)?.isMobile"
                                class="col col-md-7 col-lg-6 offset-lg-1 offset-xl-2 d-none d-md-block"
                                [ngClass]="{ searching: searchStateService.productSearchInProgress$ | async }"
                            >
                                <ng-container *ngIf="searchStateService.productSearchResults$ | async as searchResults">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            products;
                                            context: {
                                                results: searchResults,
                                                url: searchPageUrl
                                            }
                                        "
                                    ></ng-container>

                                    <ng-container [ngTemplateOutlet]="commonLink"
                                                  [ngTemplateOutletContext]="{
                                                    searchResults: searchResults,
                                                    searchPageUrl: searchPageUrl,
                                                    content: ('search.links.seeAllResults' | translateSafe)
                                                  }"
                                    ></ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #noResults>
    {{ 'search.feedback.noResults' | translateSafe }}
</ng-template>

<ng-template #products let-results="results" let-url="url">
    @if ((results | mergeWithRetailMedia); as products) {
        @if (products.length) {
            <section class="product-section">
                <h3 class="display-body">{{ 'search.headings.products' | translateSafe }}</h3>
                <div>
                    <ul class="products">
                        <li class="product" *ngFor="let product of products; index as i">
                            <app-product-mini
                                [product]="product"
                                [show]="{ properties: true, discount: true }"
                                [linkToProduct]="true"
                                (productClicked)="
                                    trackProductClick(
                                        searchInputComponent.searchInput.value,
                                        product.productName,
                                        i,
                                        results.total
                                    )
                                "
                            ></app-product-mini>
                        </li>
                    </ul>
                </div>
            </section>
        }
    }
    <ng-container *ngIf="results.total as total">
        <ng-container
            *ngTemplateOutlet="
                seeAllLink;
                context: {
                    content: ('search.links.seeAllResults' | translateSafe) + ' (' + total + ')',
                    url: url
                }
            "
        ></ng-container>
    </ng-container>
</ng-template>

<ng-template #commonLink let-searchResults="searchResults" let-searchPageUrl="searchPageUrl" let-content="content">
    @if (searchResults?.redirectUrlsSetup; as redirects) {
        @if (redirects.length) {
            <ng-container
                *ngTemplateOutlet="
                    seeAllLink;
                    context: {
                        results: searchResults,
                        content: content,
                        url: searchPageUrl
                    }
                "
            ></ng-container>
        }
    }
</ng-template>

<ng-template #seeAllLink let-content="content" let-url="url" let-results="results">
    <div class="see-all-link">
        @if (results?.redirectUrlsSetup; as redirects) {
            @for (redirect of redirects; track $index) {
                <app-arrow-link
                    *ngIf="redirect"
                    [link]="{ url: redirect.redirectUrl, name: redirect.title }"
                    [title]="redirect.title"
                >{{ redirect.title }}
                </app-arrow-link
                >
            }
        }

        @if (!results || results?.redirectUrlsSetup?.length === 0) {
            @if (searchStateService.productResultSearchString$ | async; as searchString) {
                <app-arrow-link
                    [link]="{ url: url }"
                    [queryParams]="filterService.toFilterParams(searchString | getQueryParamForLink)"
                    (linkClick)="searchStateService.close()"
                >
                    {{ content }}
                </app-arrow-link>
            }
        }
    </div>
</ng-template>
